const Operation = () => import("@/components/atm-front/cases/case/Acoustic/Operation.vue");
const Portions = () => import("@/components/atm-front/cases/case/Acoustic/Portions.vue");

const PortionDetail = () => import("@/components/atm-front/cases/case/Acoustic/PortionDetail.vue");

export default [
  {
    path: "",
    name: "Operation",
    component: Operation,
  },
  {
    path: "portions",
    name: "Portions",
    component: Portions,
  },
  {
    path: "portions/:portionUuid",
    name: "PortionDetail",
    component: PortionDetail,
  },
];
